import fb from 'firebase'
import "firebase/auth"

export default {
	state: {
		user: null,
		unsubscribeAuth: null
	},
	mutations: {
		setUser (state, payload) {
			state.user = payload
		},
		setgameId (state, payload) {
			state.gameId = payload
		},
		setUnsubscribeAuth (state, payload){
			state.unsubscribeAuth = payload
		}
	},
	actions: {
		initAuth ({dispatch, commit, state}) {
			return new Promise((resolve) => {
				//отписка от подписки 
				if (state.unsubscribeAuth) {
					state.unsubscribeAuth()
				}
				let unsubcribe = fb.auth().onAuthStateChanged((user) => {
					if (user) {
						fb.auth().currentUser.getIdTokenResult()
						.then(function ({claims}) {
							dispatch('stateChanged', claims) 
							resolve(claims)
						})
						.catch(error =>  {
							commit('setError', error.message)
						})
					}
					else {
						dispatch('stateChanged')
						resolve();
					}
					
				});//
				commit('setUnsubscribeAuth', unsubcribe)
			}) 
		},
		async registerUser ({commit}, payload) {
			
			commit('clearError')
			commit('setLoading', true)
		
			try {
				await fb.auth().createUserWithEmailAndPassword(payload.email, payload.password)
				//console.log(user)
				commit('setLoading', false)
			}
			catch(error) {
				commit('setLoading', false)
				commit('setError', error.message)
				throw error
			}
		},
		async loginUser({commit}, {email, password}) {
			commit('clearError')
			commit('setLoading', true)
			try {
				await fb.auth().signInWithEmailAndPassword(email, password)
				//uid
				commit('setLoading', false)	
			}
			catch(err) {
				commit('setLoading', false)
				commit('setError', err.message)
				throw err
			}
		},
		async stateChanged ({dispatch, commit}, payload) {

			if (payload) {
				await dispatch('fetchUserData', payload.user_id)
				
				if (payload.admin) {
					await dispatch('fetchAllUsers')
				}
				else {	
					await dispatch('fetchProducts')
					await dispatch('fetchChannels')
					await dispatch('fetchSpots')
					await dispatch('fetchProjects')
					await dispatch('fetchIndependentChains')
					await dispatch('fetchSegments')
					await dispatch('fetchSummary')
					await dispatch('fetchAdjustedSales')
					await dispatch('fetchPrevious')
				}
				//set user
				commit('setUser', payload.user_id)							
			}
			else {
				commit('setUser', null)
			}
		},
		logoutUser ({commit}) {
			//console.log('signOut!!!')
			fb.auth().signOut()
			commit('setUser', null)
		}
	},
	getters: {
		userId (state) {
			return state.user
		},
		loggedIn (state) {
			return Boolean(state.user !== null)
		}
	}
}